import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { useAppSelector } from "../../../redux/hooks";
import type { TagEntityType } from "../../../zodios/apiDefinitions/api/tags";

interface UseTagsQueryParams {
  entityType?: TagEntityType;
  marketplace?: string;
  type?: string;
  origin?: string;
}

export const useTagsQuery = (params: UseTagsQueryParams = {}, options?: { enabled?: boolean }) => {
  const reduxMarketplace = useAppSelector((state) => state.marketPlace.marketPlace);
  const marketplace = params.marketplace ?? reduxMarketplace;
  return useQuery({
    queryKey: [{ entity: "tags", params: { ...params, marketplace } }],
    queryFn: async () =>
      await apiClient.getTags({
        queries: {
          entity_type: params.entityType,
          marketplace,
          type: params.type,
          origin: params.origin,
        },
      }),
    ...options,
  });
};
